import React from "react";
import "../styles/loader.css";

const Loader: React.FC = (): React.JSX.Element => {
  return (
    <div className="loaderContainer" data-testid="loaderContainer">
      <span className="loaderContainer__loader" data-testid="loader"></span>
    </div>
  );
};

export default Loader;
